<!-- 总代理商后台菜单栏 -->
<template>
  <div class="main">
    <el-container>
      <el-header class="header">
        <div class="header-l">
          <img src="../assets/logo反黑.png" alt="">
        </div>
        <div class="header-r">
          <div class="enter_name">{{ tooken.username }}</div>
          <el-dropdown trigger="click">
            <div class="account_name">
              <span>设置</span>
              <i class="el-icon-arrow-down" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item divided>
                <span><el-link :underline="false" @click.native="about">退出登录</el-link></span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-container class="c-height">
        <el-aside width="22rem">
          <el-menu default-active="1">
            <el-submenu :index="item.id + ''" v-for="item in navigation" :key="item.id">
              <template slot="title">
                <i :class="item.icon" style="margin-right: 25px;"></i>
                <span>{{ item.pri_name }}</span>
              </template>
              <el-menu-item :index="subItem.id + ''" v-for="subItem in item.children" :key="subItem.id">
                <router-link :to="subItem.module_name" tag="div">{{ subItem.pri_name }}</router-link>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </el-aside>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import qs from "qs";
export default {
  data() {
    return {
      tooken: "",
      title: {},
      navigation: [],
      legeList: [],
      defaultProps: {
        children: "children",
        label: "pri_name",
      },
    };
  },
  mounted() {
    // if (window.sessionStorage.getItem("title")) {
    //   let title = JSON.parse(window.sessionStorage.getItem("title"));
    //   this.title = title;
    //   var a = document.title;
    //   document.title = title[0].website + "-" + a;
    // }
    if (window.sessionStorage.getItem("userinfone")) {
      let userinfo = JSON.parse(window.sessionStorage.getItem("userinfone"));
      this.tooken = userinfo;
    }
    this.HiddenDisplay();
    // this.abouts()
  },
  methods: {
    // abouts() {
    //   this.axios
    //     .post(
    //       "/api/setup/getSetList",
    //       qs.stringify({
    //         totaltoken: this.username.totaltoken,
    //       }),
    //       {
    //         headers: {
    //           "Content-Type": "application/x-www-form-urlencoded",
    //         },
    //       }
    //     )
    //     .then((res) => {
    //       if (res.data.msg == "登录超时") {
    //         this.$router.push("/Tagent");
    //       }
    //       var title = res.data.data;
    //       sessionStorage.setItem("title", JSON.stringify(title));
    //     })
    //     .catch(function (err) {});
    // },
    //  左边列表显示隐藏
    HiddenDisplay() {
      this.axios
        .post(
          "/api/role/getRolePrive",
          qs.stringify({
            role_id: this.tooken.role_id,
            totaltoken: this.tooken.totaltoken,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
          this.navigation = res.data.data;
          let arr = res.data.data.map((item) => {
            switch (item.id) {
              case 1:
                item.icon = "iconfont icon-a-fengkongguanli1"
                break
              case 7:
                item.icon = "iconfont icon-crmxitong"
                break
              case 11:
                item.icon = "iconfont icon-dailishangguanli"
                break
              case 16:
                item.icon = "iconfont icon-renqunguanli"
                break
              case 18:
                item.icon = "iconfont icon-a-huashuguanli1"
                break
              case 20:
                item.icon = "iconfont icon-xiansuo"
                break
              case 22:
                item.icon = "iconfont icon-a-yonghuguanli1"
                break
              case 25:
                item.icon = "iconfont icon-zuzhijiagou"
                break
              case 30:
                item.icon = "iconfont icon-wodeziliao"
                break
            }
            return item
          })
          this.navigation = arr;
        })
        .catch(function (err) {
          // if(err.data.code==0){
          //   this.$router.push("/Tagent");
          // }
        });
    },
    aaa(data) {
      let ddd = data;
      if (ddd.module_name != "") {
        this.$router.push("/Tagent/general/" + ddd.module_name);
      }
    },
    about() {
      this.axios
        .post(
          "/api/user/totalOut",
          qs.stringify({
            id: this.tooken.id,
            totaltoken: this.tooken.totaltoken,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "退出成功！") {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.$router.push("/Tagent");
          }
        })
        .catch(function (err) { });
    },
  },
  components: {},
};
</script>
<style lang="scss" scoped>
.c-height {
  height: calc(100vh - 6rem);
}

/* header */
.header {
  display: flex;
  height: 6rem !important;
  justify-content: space-between;
  align-items: center;
  padding: 0 2.4rem 0 4.3rem;
  box-shadow: .3rem .3rem 2rem 0 rgba(0, 0, 0, 0.1);
}

.header-l img {
  width: 13.4rem;
  height: 3rem;
}

.header-r {
  display: flex;
  align-items: center;
}

.account_name {
  display: flex;
  align-items: center;
}

.enter_name,
.account_name span {
  font-size: 1.6rem;
  font-weight: 500;
  color: #333333;
  line-height: 2.2rem;
}

.account_name span {
  margin: 0 1.9rem 0 3rem;
  cursor: pointer;
}

/* aside */
.el-aside {
  box-shadow: 1rem 0 .8rem -0.8rem rgba(0, 0, 0, 0.1);
}

.el-menu {
  border: none;
}

.el-menu-item {
  display: flex;
  color: #666;
  font-size: 1.6rem;
}

::v-deep .el-submenu__title {
  color: #666;
  font-size: 1.6rem;
  padding: 0 2rem 0 3rem;
  height: 5.6rem;
  line-height: 5.6rem;
}

.iconfont {
  font-size: 1.6rem;
  margin-right: 2rem !important;
}

.is-active .iconfont {
  color: #49B372 !important;
}

.el-menu-item.is-active {
  color: #0C2616;
  font-size: 1.6rem;
  background: #E6FFF1;
}
</style>
